import { render, staticRenderFns } from "./tradeLogs.vue?vue&type=template&id=06b9dc94"
import script from "./tradeLogs.vue?vue&type=script&lang=js"
export * from "./tradeLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports